module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_unfair-competition-business-secrets-and-confidential-information.ec108ca4.png";